package ru.villawonka.app.domain.model

enum class RentTypeDomain {
    DAILY,
    MONTHLY,
    ANNUALLY,
    PERIOD
}